"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_VITALS_NO_CLS = void 0;
const webVitals = __importStar(require("web-vitals/attribution"));
const webVitals_1 = require("../constants/webVitals");
const CLSMetric_1 = __importDefault(require("./CLSMetric"));
const WebVitalsMetric_1 = require("./WebVitalsMetric");
/**
 * All metrics generally behave the same except for CLS, so make a list of all
 * metrics *except* CLS so we can interact with them as a group.
 * @private
 */
const WEB_VITALS_NO_CLS = webVitals_1.WEB_VITALS.filter(metric => metric !== 'CLS');
exports.WEB_VITALS_NO_CLS = WEB_VITALS_NO_CLS;
/** Track and measure Web Vitals metrics and their attribution details */
class WebVitalsMetrics {
    /**
     * Create a new `WebVitalsMetrics` instance which will instantiate a
     * `WebVitalsMetric` subclass for each Web Vitals metric accessible via
     * `this.<metricName>`. (E.g., `this.CLS` will be an instance of the CLS
     * metric, `this.FID` will be an instance of the FID metric, etc.)
     *
     * @param {Debug} debug - Global Debug instance
     */
    constructor(debug) {
        // Create a subclass of `WebVitalsMetric` for CLS to support custom
        // behavior
        this.CLS = new CLSMetric_1.default(debug);
        // Create subclasses of `WebVitalsMetric` for all remaining metrics
        WEB_VITALS_NO_CLS.forEach(metricName => {
            const reporter = webVitals[`on${metricName}`];
            const goodThreshold = webVitals_1.WEB_VITALS_THRESHOLDS[metricName].good;
            const Subclass = (0, WebVitalsMetric_1.createMetricSubclass)(metricName, reporter, debug, goodThreshold);
            this[metricName] = new Subclass();
        });
    }
}
exports.default = WebVitalsMetrics;
